import type { ErrorEvent, Message } from '../../state/chatTypes';

/** One message or inline error in the chronological chat feed. */
export type TimelineItem =
  | { kind: 'message'; data: Message }
  | { kind: 'error'; data: ErrorEvent };

/**
 * Interleaves message and error records by creation timestamp.
 * @param messages - Active conversation messages
 * @param errorEvents - Active conversation inline errors
 */
export const buildMessageTimeline = (
  messages: ReadonlyArray<Message>,
  errorEvents: ReadonlyArray<ErrorEvent>
): TimelineItem[] => {
  const timeline: TimelineItem[] = [
    ...messages.map(
      (message): TimelineItem => ({ kind: 'message', data: message })
    ),
    ...errorEvents.map(
      (error): TimelineItem => ({ kind: 'error', data: error })
    ),
  ];
  timeline.sort((left, right) =>
    left.data.createdAt.localeCompare(right.data.createdAt)
  );
  return timeline;
};
